/// <reference types="react-scripts" />
import * as React from "react";
import * as taskService from "source/models/services/taskService";
import { DashboardChart } from "source/components/framework/DashboardChart";
import { IDashboardChartData } from "source/models/report/dashboardChartData";
import { AppUtils } from "source/framework/appUtils";
import { useEffect } from "react";

export interface IFrontTaskChartProp {
    companyId: string;
    id: string;
    title: string;
}

export interface FrontTaskChartState {
    isLoading: boolean;
    dashboardChartData: IDashboardChartData;
}

export const FrontTaskChart = (props: IFrontTaskChartProp) => {
    const [state, setState] = React.useState<FrontTaskChartState>({
        dashboardChartData: null,
        isLoading: true
    });

    const createChart = async () => {
        setState((old) => ({ ...old, isLoading: true }));
        const dashboardChartData = await AppUtils.callService(() => taskService.getChartDataById(props.companyId, props.id), false, true, () => { setState((old) => ({ ...old, isLoading: false })); });
        if (!dashboardChartData) return;
        dashboardChartData.title = "";
        setState((old) => ({
            ...old,
            dashboardChartData
        }));
    };

    useEffect(() => {
        if (!props.companyId || !props.id) return;
        createChart();
    }, [props.companyId, props.id, props.title]);

    return (
        <DashboardChart
            panelId={props.id}
            title={props.title}
            chartData={state.dashboardChartData}
            isLoading={state.isLoading}
            onShowProperties={null}
        />
    );
};